
import React from 'react';

interface FormatterProps {
  value?: number;
  type: 'time' | 'size';
}

export const MetricFormatter: React.FC<FormatterProps> = ({ value, type }) => {
  const formatTime = (time?: number): string => {
    if (time === undefined || time === null) return 'N/A';
    if (time < 1) return '<1ms';
    return `${Math.round(time)}ms`;
  };

  const formatSize = (bytes?: number): string => {
    if (bytes === undefined || bytes === null) return 'N/A';
    if (bytes < 1024) return `${bytes}B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
  };

  const getTimingColor = (time?: number): string => {
    if (time === undefined || time === null) return 'text-gray-400';
    if (time < 500) return 'text-green-500';
    if (time < 1000) return 'text-green-400';
    if (time < 2000) return 'text-yellow-500';
    if (time < 3000) return 'text-yellow-600';
    return 'text-red-500';
  };

  return (
    <span className={type === 'time' ? getTimingColor(value) : ''}>
      {type === 'time' ? formatTime(value) : formatSize(value)}
    </span>
  );
};

export const getTimingColor = (time?: number): string => {
  if (time === undefined || time === null) return 'text-gray-400';
  if (time < 500) return 'text-green-500';
  if (time < 1000) return 'text-green-400';
  if (time < 2000) return 'text-yellow-500';
  if (time < 3000) return 'text-yellow-600';
  return 'text-red-500';
};

export const formatTime = (time?: number): string => {
  if (time === undefined || time === null) return 'N/A';
  if (time < 1) return '<1ms';
  return `${Math.round(time)}ms`;
};

export const formatSize = (bytes?: number): string => {
  if (bytes === undefined || bytes === null) return 'N/A';
  if (bytes < 1024) return `${bytes}B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
};
